import React, {Component} from 'react';
import AddressAutoComplete from '../containers/AddressAutoComplete';
import './attendenceAddressTab.css';
import AttendenceMap from './AttendanceMap';
import {connect} from 'react-redux';
import request from 'superagent';
import Select from 'react-select';
import AddressModal from '../attendance/tabs/AddressModal';
import {
  findAllSortedByDistanceForCompanies,
  updateFavoriteDestination,
} from '../../api/address_helper';
import toastr from 'toastr';
import {updateConcessionaire} from '../../api/address_helper';
import {
  onChangeEstimationDistance,
  onChangeEstimationTime,
  setAttendanceOriginAddress,
} from '../../actions/attendence_actions';
import Swal from 'sweetalert2';
import {
  loadFavoriteDestiantionList,
  onAddressChange,
  changeFavoriteDestination,
  changeRequestDestiny,
} from '../../actions/address_actions';
import {CODIGO_DAF, USUARIO_TIPO_REBOQUEME} from '../../reducers/constants/index';
import PropTypes from 'prop-types';
import {toTextPlainTime} from '../../utils/time_helper';

const originAddressStyles = {
  menu: (provided, state) => {
    return {
      ...provided,
      zIndex: 999999,
    };
  },
  option: (provided, state) => {
    return {
      ...provided,
      cursor: 'pointer',
    };
  },
};

const codigoDAF = '2322661870558778503';
const codigoKIA = '2735238496074601893';

class AttendenceAddressTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpened: false,
      favoriteDestination: null,
      favoriteDestinationCode: null,
      newCustomerAddress: this.props.requestDestiny,
      addressesSorted: [],
      isLoading: false,
    };
    this.saveConcessionaria = this.saveConcessionaria.bind(this);
    this.getCompanyCode = this.getCompanyCode.bind(this);
  }

  async handleFavoriteDestinationsUpdate() {
    const addressesSorted = await this.getFavoriteDestinations();
    this.setState({addressesSorted});
  }

  componentDidUpdate(prevProps) {
    if (prevProps.requestDestiny !== this.props.requestDestiny) {
      this.handleFavoriteDestinationsUpdate();
    }
  }

  componentDidMount() {
    const {requestDestiny} = this.props;

    if (requestDestiny) this.handleFavoriteDestinationsUpdate();
  }

  getCompanyCode = () => {
    const user_info = JSON.parse(localStorage.getItem('user_info'));
    const isSoon = user_info.usuario.tipoUsuario === USUARIO_TIPO_REBOQUEME;

    let companyCode = '';

    if (this.props.company) {
      companyCode = this.props.company.value;
    }

    if (user_info.empresa && !isSoon) {
      companyCode = user_info.empresa.codigo;
    }

    return companyCode;
  };

  async getFavoriteDestinations() {
    this.setState({isLoading: true});
    const user_info = JSON.parse(localStorage.getItem('user_info'));
    const isSoon = user_info.usuario.tipoUsuario === USUARIO_TIPO_REBOQUEME;
    const isDaf = user_info.empresa && user_info.empresa.codigo === CODIGO_DAF;

    const {requestDestiny} = this.props;
    const companyCode = this.getCompanyCode();

    const validationFavoriteDestinations =
      requestDestiny.latitude && companyCode && (isSoon || isDaf);
    const favoriteDestinations =
      validationFavoriteDestinations &&
      (await findAllSortedByDistanceForCompanies(
        requestDestiny.latitude,
        requestDestiny.longitude,
        companyCode,
      ));
    this.setState({isLoading: false});

    try {
      const addressesSorted = favoriteDestinations
        ? favoriteDestinations.data.map((destination) => {
            return {
              className: 'favorite-address',
              codigo: destination.code,
              label: '✭  ' + destination.description,
              value: {
                ...destination,
              },
              location: {
                lat: Number(destination.address.latitude),
                lng: Number(destination.address.longitude),
                distance: destination.distance,
                time: destination.time,
              },
              ...destination.address,
              type: 'favorite',
            };
          })
        : [];

      if (
        this.props.originAddress &&
        this.props.originAddress.value &&
        this.props.originAddress.value.codigo
      ) {
        const selectedAddress = addressesSorted.find(
          (address) => address.value.code === this.props.originAddress.value.codigo,
        );
        this.props.addressSelected('enderecoOrigem', {...selectedAddress});
      }
      return addressesSorted;
    } catch (error) {
      console.error('Erro ao buscar distâncias:', error);
      return [];
    }
  }

  saveConcessionaria = (codigo) => {
    updateFavoriteDestination(codigo, {
      enderecoFavorito: this.state.favoriteDestinationCode,
    }).then((e) =>
      e.codigoRetorno === 201
        ? toastr.success(e.mensagemCliente)
        : toastr.error(e.mensagemCliente),
    );
  };

  changeOrigin = (address) => {
    let favoriteDestination;
    let favoriteDestinationCode;
    try {
      favoriteDestinationCode = address.value.code;
      favoriteDestination = address.value.favoriteAddressContacts;
    } catch (error) {
      favoriteDestination = null;
      favoriteDestinationCode = null;
    }
    this.setState({favoriteDestination, favoriteDestinationCode});
    this.props.addressSelected('enderecoOrigem', {...address});
  };

  convertMeterToKm = (meter) => {
    return meter ? (meter / 1000).toFixed(2) : 0;
  };

  getTooltipInfo = ({value = {}} = {}) => {
    const {address, email, ...others} = value;
    if (address) {
      let tooltip = `${address.place}\n${address.district}`;

      if (email) {
        tooltip += `\n${email}\n`;
      } else {
        tooltip += '\n';
      }

      if (others.contact && others.cellPhone) {
        tooltip += `${others.contact} ${others.cellPhone} `;
      }

      if (others.contact2 && others.cellPhone2) {
        tooltip += `| ${others.contact2} ${others.cellPhone2} `;
      }

      if (others.contact3 && others.cellPhone3) {
        tooltip += `| ${others.contact3} ${others.cellPhone3}`;
      }

      if (address.code) {
        tooltip += `${address.code}`;
      }
      return tooltip;
    }

    return null;
  };

  formatNewAddress = (endereco) => {
    const findAddressComponents = (componentes, word) => {
      const location = componentes.find((info) => info.types.includes(word));

      return location ? location.long_name : null;
    };

    let newObj = {};
    if (endereco) {
      const gmaps = endereco.gmaps.address_components;
      newObj = {
        bairro: findAddressComponents(gmaps, 'sublocality_level_1'),
        cep: findAddressComponents(gmaps, 'postal_code'),
        cidade: findAddressComponents(gmaps, 'administrative_area_level_2'),
        estado: findAddressComponents(gmaps, 'administrative_area_level_1'),
        latitude: endereco.location.lat,
        longitude: endereco.location.lng,
        numero: findAddressComponents(gmaps, 'street_number'),
        pais: findAddressComponents(gmaps, 'country'),
        logradouro: endereco.description,
      };
    }

    this.setState({newCustomerAddress: newObj});
  };

  alterarEndereco = () => {
    const {attendanceId, updateAtendimentoTab} = this.props;
    const selectedAddress = this.state.newCustomerAddress;

    if (selectedAddress.logradouro === this.props.requestDestiny.logradouro) {
      return toastr.error('Nenhum endereço selecionado.');
    }

    Swal.fire({
      title: 'Você tem certeza?',
      text: 'Você deseja alterar o endereço?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#5c40ff',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, alterar!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        changeRequestDestiny(attendanceId, selectedAddress)
          .then((results) => {
            toastr.success('Alteração realizada com sucesso!');
            updateAtendimentoTab();
          })
          .catch((error) => {
            toastr.error('Não foi possivel fazer a alteração');
          });
      }
    });
  };

  alterarConcessionaria = () => {
    const {attendanceId, updateAtendimentoTab} = this.props;
    const selectedConcessionaria = this.state.favoriteDestination;
    const codigoEmpresa = this.state.favoriteDestinationCode;

    if (!selectedConcessionaria) {
      return toastr.error('Nenhuma concessionária selecionada.');
    }

    Swal.fire({
      title: 'Você tem certeza?',
      text: 'Você deseja alterar a concessionária?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#5c40ff',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, alterar!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        changeFavoriteDestination(attendanceId, codigoEmpresa)
          .then((results) => {
            toastr.success('Alteração realizada com sucesso!');
            updateAtendimentoTab();
          })
          .catch((error) => {
            toastr.error('Não foi possivel fazer a alteração');
          });
      }
    });
  };

  valueDistance = () => {
    if (this.props.originAddress.location)
      return this.convertMeterToKm(this.props.originAddress.location.distance);
    return '';
  };

  valueTime = () => {
    if (this.props.originAddress.location)
      return toTextPlainTime(this.props.originAddress.location.time);
    return '';
  };

  render() {
    const {
      requestOrigin,
      requestDestiny,
      attendanceTab,
      company: {value: empresa} = {},
      attendence,
      attendanceId,
      companyName: {label: companyName} = {},
    } = this.props;
    const codigo = attendence.attendanceTab.codigo;

    const favoriteDestinations = this.state.addressesSorted;
    const tooltipConcessionaria = this.getTooltipInfo(this.props.originAddress);
    const favoriteDestinationState = this.state.favoriteDestination;

    const user_info = JSON.parse(localStorage.getItem('user_info'));
    const isSoon = user_info.usuario.tipoUsuario === USUARIO_TIPO_REBOQUEME;
    const isDaf = user_info.empresa && user_info.empresa.codigo === CODIGO_DAF;

    function getLocais() {
      try {
        const locais =
          favoriteDestinationState ||
          attendence.attendanceTab.enderecoFavorito.contatosEnderecoFavorito ||
          [];
        return locais;
      } catch (error) {
        return [];
      }
    }

    const locais = getLocais();

    return (
      <section>
        {this.state.isModalOpened && (
          <AddressModal close={() => this.setState({isModalOpened: false})} tabs={locais} />
        )}
        <div id="attendence-origin" className="col-sm-6">
          <div className="row">
            <div className="col-sm-12">
              <label className="font-normal p-w-xs">Local do Cliente</label>
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="fas fa-flag" />
                </span>
                {attendanceId ? (
                  <AddressAutoComplete
                    placeholder="Endereço de Destino"
                    id="enderecoDestino"
                    isDaf={isDaf}
                    initialValue={this.state.newCustomerAddress.logradouro}
                    actionSelected={(endereco) => this.formatNewAddress(endereco)}
                  />
                ) : (
                  <AddressAutoComplete
                    placeholder="Endereço de Destino"
                    id="enderecoDestino"
                    isDaf={isDaf}
                    initialValue={requestDestiny ? requestDestiny.logradouro : null}
                  />
                )}
              </div>
            </div>
          </div>
          {(isDaf || isSoon) && (
            <section>
              <div className="row" style={{marginTop: '15px'}}>
                <div className="col-sm-12">
                  <label className="font-normal p-w-xs">
                    Concessionária{'  '}
                    {!!locais.length && favoriteDestinationState !== undefined && (
                      <span
                        style={{cursor: 'pointer'}}
                        onClick={() => this.setState({isModalOpened: true})}>
                        <i className="fa fa-info-circle" />
                      </span>
                    )}
                  </label>
                  <div className="input-group">
                    <span className="input-group-addon">
                      <i className="fas fa-location-arrow" />
                    </span>
                    <Select
                      id="enderecoOrigem"
                      options={favoriteDestinations}
                      isLoading={this.state.isLoading}
                      onChange={this.changeOrigin}
                      value={this.props.originAddress}
                      styles={originAddressStyles}
                      isDisabled={this.props.isDafRecusa}
                    />
                    {this.state.favoriteDestination && (
                      <span
                        style={{cursor: 'pointer'}}
                        onClick={() => this.saveConcessionaria(codigo)}
                        className="input-group-addon btn btn-primary">
                        <i className="fas fa-save" />
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="row" style={{marginTop: '15px'}}>
                <div className="col-sm-6">
                  <label className="font-normal p-w-xs">Km</label>
                  <div className="input-group">
                    <span className="input-group-addon">
                      <i className="fas fa-car" />
                    </span>
                    <input
                      value={this.valueDistance()}
                      type="number"
                      className="form-control"
                      disabled
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <label className="font-normal p-w-xs">Tempo</label>
                  <div className="input-group">
                    <span className="input-group-addon">
                      <i className="fas fa-clock" />
                    </span>
                    <input
                      type="text"
                      value={this.valueTime()}
                      className="form-control"
                      disabled
                    />
                  </div>
                </div>
              </div>

              {(attendanceTab.kmAtualValidado || attendanceTab.kmTotalRodadoMecanico) &&
                empresa === codigoDAF && (
                  <div className="row" style={{marginTop: '15px'}}>
                    <div className="col-sm-6">
                      <label className="font-normal p-w-xs">Km Atual Validado</label>
                      <div className="input-group">
                        <span className="input-group-addon">
                          <i className="fas fa-car" />
                        </span>
                        <input
                          value={attendanceTab.kmAtualValidado}
                          type="number"
                          className="form-control"
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <label className="font-normal p-w-xs">Km Total Técnico</label>
                      <div className="input-group">
                        <span className="input-group-addon">
                          <i className="fas fa-clock" />
                        </span>
                        <input
                          type="text"
                          onChange={(e) => this.props.onChangeTime(e.target.value)}
                          value={attendanceTab.kmTotalRodadoMecanico}
                          className="form-control"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                )}
            </section>
          )}
          {user_info.usuario.perfis &&
            user_info.usuario.perfis.some((perfil) => perfil.nome === 'Manager Empresa') &&
            attendanceId && (
              <button
                style={{marginTop: '140px', marginRight: '10px'}}
                className="btn btn-primary"
                onClick={this.alterarEndereco}>
                Alterar Endereço
              </button>
            )}
          {attendanceId && (isDaf || isSoon) && (
            <button
              style={{marginTop: '140px'}}
              className="btn btn-primary"
              onClick={this.alterarConcessionaria}>
              Alterar Concessionária
            </button>
          )}
        </div>
        <div className="col-sm-6">
          <AttendenceMap
            id="attendence-map"
            requestOrigin={{
              ...requestOrigin,
              lat: requestOrigin.latitude,
              lng: requestOrigin.longitude,
            }}
            tipoServico="REBOQUE"
            cancelEstimation={!!this.props.time}
            requestDestination={{
              ...requestDestiny,
              lat: requestDestiny.latitude,
              lng: requestDestiny.longitude,
            }}
            style={{
              height: '390px',
            }}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  requestOrigin: state.service.enderecoOrigem,
  requestDestiny: state.service.enderecoDestino,
  attendanceTab: state.attendance.attendanceTab,
  endereco: state.attendance.attendanceTab.endereco,
  enderecoFavorito: state.attendance.attendanceTab.enderecoFavorito,
  distance: state.attendance.estimation.distance,
  time: state.attendance.estimation.time,
  originAddress: state.attendance.originAddress,
  empresa: state.login.user_info.empresa && state.login.user_info.empresa.codigo,
  attendence: state.attendance,
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChangeTime: (value) => dispatch(onChangeEstimationTime(value)),
    onChangeDistance: (value) => dispatch(onChangeEstimationDistance(value)),
    loadFavoriteList: () => dispatch(loadFavoriteDestiantionList()),
    addressSelected: (id, address) => {
      dispatch([
        onAddressChange(id, address),
        setAttendanceOriginAddress({
          ...address,
          label: address.value.description,
        }),
      ]);
    },
  };
};

AttendenceAddressTab.propTypes = {
  company: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default connect(mapStateToProps, mapDispatchToProps)(AttendenceAddressTab);
